export default __webpack_public_path__ + "static/media/AusmaLovelace.d940a2bd.png";